const USER_TEMPLATE = `All available student data (typed or scanned — use everything below):

{{STUDENT_DATA}}

---

Using the process in the system instructions:
1. From the data above, state the student's grade and subject(s).
2. For that subject, identify the Curricular Competency Area(s) that apply.
3. From the goal bank only, select 2–4 exact "I can" goals (and "by ..." objectives) that match this grade, subject, and area. Do not add goals that are not in the goal bank.`;

/**
 * @param {string} studentData - buildAllStudentDataForPrompt(...) ka result
 * @returns {string} Full user prompt
 */
export function getUserPrompt(studentData) {
  return USER_TEMPLATE.replace("{{STUDENT_DATA}}", studentData || "No data provided.");
}
